import apiRequest from 'utils/api/apiRequest';
import * as URLS from './urls';

export const portfolioOverviewApi = {
  excelExport: (regnos, monitorIDs) => {
    return apiRequest(URLS.MONITOR_PORTFOLIO_EXCEL_FILTERED, {
      responseType: 'blob',
      method: 'post',
      data: { regnos: regnos, monitorIds: monitorIDs },
    });
  },
  getMonitorPortfolio: (monitorIDs) => {
    return apiRequest(URLS.PORTFOLIO_OVERVIEW, { method: 'post', data: monitorIDs });
  },
  load: () => apiRequest(URLS.PORTFOLIO),
};
